module.exports = __webpack_public_path__ + "static/media/gt3-downhill.7aff6fb6.jpg";